export enum CampaignType {
  SURVEY_VOICE = 'SURVEY_VOICE',
  SURVEY_SMS = 'SURVEY_SMS',
  NOTIFICATION_VOICE = 'NOTIFICATION_VOICE',
  NOTIFICATION_SMS = 'NOTIFICATION_SMS'
}

export interface Campaign {
  id: string;
  name: string;
  type: CampaignType;
  active: boolean;
  credits: number;
  responseRate: number | null;
  deliveryRate: number | null;
}

export interface CreditUsage {
  used: number;
  limit: number;
}

export interface AgencyOverview {
  name: string;
  nextCreditRenew: string;
  campaigns: CreditUsage;
  smsMessages: CreditUsage;
  voiceMessages: CreditUsage;
}

export interface SurveyStats {
  smsSent: number;
  voiceCampaignDuration: string;
  deliveryRate: number;
  campaignsOpenRate: number;
  surveySubmissionRate: number;
  optOut: number;
}

export interface Agency {
  id: string;
  name: string;
  credits: number;
  smsRate: number;
  voiceRate: number;
  hasWarning?: boolean;
}

export interface AllAgenciesOverview {
  totalAgencies: number;
  campaigns: CreditUsage;
  smsMessages: CreditUsage;
  voiceMessages: CreditUsage;
  nextCreditRenew: string;
}

export type CampaignStatus = 'active' | 'scheduled' | 'completed';

export interface DashboardCampaign {
  id: string;
  name: string;
  agencyId: string;
  agencyName: string;
  type: CampaignType;
  contacts: number;
  deliveryRate: number;
  status: CampaignStatus;
}
